// extracted by mini-css-extract-plugin
module.exports = {"button":"_3_Ozh1xIkutWoTIuxPhs4N"};